<template>
    <!-- LOGGED -->
    <div v-if="isLogged" id="block_login" class="block block-login block-login-logged">
        <div class="block-title">
            <span>Mon compte client</span>
        </div>

        <div class="actions">
            <a class="btn btn--border" :href="this.baseUrl + '/customer/account/'">Mon compte</a>
            <a class="btn btn--border" :href="this.baseUrl + '/sales/order/history/'">Mes commandes</a>
            <a class="btn btn--gradient" :href="this.baseUrl + '/customer/account/logout/'">Déconnexion</a>
        </div>
    </div>


    <!-- NOT LOGGED -->
    <div v-else id="block_login" class="block block-login block-login-not-logged">
        <div class="block-title">
            <span>Mon compte client</span>
        </div>

        <div class="block-subtitle">
            Connectez-vous avec vos identifiants de connexion ou créez votre compte        
        </div>

        <Messages
            v-for="(errorMessage, index) in errorMessages"
            :text="errorMessage"
            :key="index"
            :type="'danger'"
        ></Messages>
    
        <form name="formLogin" @submit.prevent="login(shouldReload)">
            
            <div class="block-content">
                <!-- mail -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group name="emailLogin">
                        <div class="mini-login-input-container">
                            <label for="mini-login"><span>Email :</span></label>
                            <input 
                                id="mini-login"
                                type="text"
                                name="emailLogin" 
                                autocomplete="email"
                                required
                                class="input-text"
                                @input="$v.formValidations.emailLogin.$touch()"
                                v-model.trim="formValidations.emailLogin"
                            >
                        </div>
                    </form-group>
                </form-wrapper>
                
                <!-- password -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group name="password">
                        <div class="input-reveal-password">
                            <label for="mini-password"><span>Mot de passe :</span></label>
                            <input 
                                id="mini-password"
                                type="password"
                                name="password"
                                autocomplete="current-password"
                                required
                                class="input-text"
                                v-model.trim="formValidations.password"
                            >
                            <div class="check-password"><span class="icon-eyes"></span></div>
                        </div>
                    </form-group>
                </form-wrapper>
                
                <div class="forgot-link-container">
                    <ObfuscateLink v-if="isObfuscate" :dataHref="forgotPasswordUrl" :className="'forgot-link'">
                        <template v-slot:content>
                            Mot de passe oublié ?
                        </template>
                    </ObfuscateLink>
                    <a v-else :href="forgotPasswordUrl" class="forgot-link">Mot de passe oublié ?</a>
                </div>
                <div class="actions">
                    <button 
                        type="button" 
                        @click="login(shouldReload)" 
                        class="btn"
                        :class="isZeborne ? 'btn--gradient' : 'btn--fill btn--blue'"
                    >
                        <span><span>Me connecter</span></span>
                    </button>
                    <ObfuscateLink v-if="isObfuscate" :dataHref="createAccountUrl" :className="'create-link'">
                        <template v-slot:content>
                            Créer mon compte
                        </template>
                    </ObfuscateLink>
                    <a v-else class="create-link" :href="createAccountUrl">Créer mon compte</a>
                </div>
            </div>
        </form>
    </div>

</template>

<script>
import loginMixin from "@/mixins/actions/account/loginMixin";
import formValidationMixin from "@/mixins/actions/validation/formValidationMixin";
import ObfuscateLink from '@/components/ObfuscateLink/ObfuscateLink.vue';
import { mapGetters } from "vuex";

export default {
    name: 'Login',

    components: { 
        ObfuscateLink
    },

    mixins: [loginMixin, formValidationMixin],

    data() {
        return {
            forgotPasswordUrl: this.baseUrl + '/customer/account/forgotpassword/',
            createAccountUrl: this.baseUrl + '/customer/account/create/',
            shouldReload: true,
        };
    },
    
    props: {
        baseUrl: {
            type: String,
            required: false,
        },
        isLogged: {
            type: Boolean,
            required: true,
        },
        isObfuscate: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        ...mapGetters({ isZeborne: "isZeborne" }),
    },

    methods: {
        closeModal () {
            return this.$emit("LoginModal::close");
        },
    },

    mounted() {
        if( document.getElementById('app').classList.contains('catalog-category-view') ){
            this.isObfuscate = true;
        }
        if( document.getElementById('app').classList.contains('catalog-product-view') ){
            this.isObfuscate = true;
        }
    },
}
</script>
